import { render } from "./init.vue?vue&type=template&id=53f51330&ts=true"
import script from "./init.vue?vue&type=script&lang=ts"
export * from "./init.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__